// Step 19 — attention queue.
//
// A single ranked list of everything the deterministic helpers deem
// "needs a human's attention": high-severity risks, preparedness
// gaps, silent buyers, unresolved contract findings, actions awaiting
// approval, and system-suggested follow-ups.
//
// Every item in this queue is either:
//   - a fact/inference the backend already labeled, or
//   - a deterministic composition of such facts.
// No fabricated confidence, no invented severity.

import AIFindingCard from "./AIFindingCard";
import { AIEmpty } from "../AIPrimitives";

export default function AIAttentionQueue({ items, workspaceId, limit }) {
  const visible = typeof limit === "number" ? (items || []).slice(0, limit) : items || [];

  if (visible.length === 0) {
    return (
      <AIEmpty
        title="Ingen registrerad observation kräver uppmärksamhet just nu"
        hint="Nya risker, köparsignaler och avtalsfynd dyker upp här när underlaget växer."
      />
    );
  }

  return (
    <div className="qai-attention-queue">
      {visible.map((f) => (
        <AIFindingCard key={f.key} finding={f} workspaceId={workspaceId} />
      ))}
    </div>
  );
}
